import { useSelector } from "react-redux";
import { useValidacionQuery } from "../services/docs";
import { RootState } from "../store";
import { Spinner } from "./Spinner";
import Button from "./ui/Button";
import { useState } from "react";

export const ValidacionComponent = ({
  validacion,
  setValidacion,
  inactivo,
}) => {
  const [correcta, setCorrecta] = useState([]);
  const [tel, setTel] = useState(false);
  const [dic, setDic] = useState(false);
  const [nac, setNac] = useState(false);
  const { seleccion } = useSelector((state: RootState) => state.ui);
  const { data, isLoading } = useValidacionQuery(seleccion);
  const validando = (selec: string) => {
    let co = correcta;
    co.push(selec);
    switch (selec) {
      case "tel":
        setTel(true);
        break;
      case "dic":
        setDic(true);
        break;
      case "nac":
        setNac(true);
        break;
    }
    setCorrecta(co);
    if (co.length === 3) {
      setValidacion(true);
    }
  };

  if (isLoading) {
    return (
      <div className="flex w-full justify-center ">
        <Spinner />
      </div>
    );
  }
  if (!isLoading && data && data.validacion.length === 0) {
    return (
      <div className="flex w-full justify-center">
        <span className="my-3 rounded-xl bg-danger px-3 py-1 text-white">
          No se encontró Información
        </span>
      </div>
    );
  }
  if (
    !isLoading &&
    data &&
    data.validacion.length > 0 &&
    data.validacion[0].IDStatus !== 1 &&
    inactivo
  ) {
    return (
      <div className="flex w-full justify-center">
        <span className="my-3 rounded-xl bg-danger px-3 py-1 text-white">
          <p>Atención!</p> El usuario que trata de atender ya no tiene activo su
          seguro. Por favor valida los datos.{" "}
        </span>
      </div>
    );
  }
  if (!isLoading && data && data.validacion.length > 0) {
    return (
      <>
        <div className="w-full">
          <h1 className="mb-5 rounded-t-xl border-b-2 border-primary py-2 pl-3 text-primary">
            Verifique la autenticidad del Cliente
          </h1>
        </div>
        <div className="mt-2 grid grid-cols-1 gap-4 px-2 sm:grid-cols-2 lg:grid-cols-3">
          {!tel && (
            <div className="card mb-6 rounded-xl bg-gray-300 pb-0">
              <h1 className="mb-2 text-sm font-bold">
                Verificación por Teléfono:
              </h1>
              <div className="grid grid-cols-2">
                <p>Teléfono de Casa:</p>
                <p>{data.validacion[0].Tel_Cas_Aseg}</p>
                <p>Teléfono Celular:</p>
                <p>{data.validacion[0].Tel_Cel_Aseg}</p>
              </div>
              <div className="mt-3 flex w-full justify-center">
                <Button onClick={() => validando("tel")}>
                  Validacion Correcta
                </Button>
              </div>
            </div>
          )}

          {!dic && (
            <div className="card mb-6 rounded-xl bg-gray-300 pb-0">
              <h1 className="mb-2 text-sm font-bold">
                Verificación por Dirección:
              </h1>
              <div className="grid grid-cols-2">
                <p>Calle:</p>
                <p>{data.validacion[0].Calle}</p>
                <p># Int:</p>
                <p>{data.validacion[0].Num_Int}</p>
                <p># Ext:</p>
                <p>{data.validacion[0].Num_Ext}</p>
                <p>Colonia:</p>
                <p>{data.validacion[0].Colonia}</p>
                <p>Delegación:</p>
                <p>{data.validacion[0].Delegacion}</p>
              </div>
              <div className="mt-3 flex w-full justify-center">
                <Button onClick={() => validando("dic")}>
                  Validacion Correcta
                </Button>
              </div>
            </div>
          )}
          {!nac && (
            <div className="card mb-6 rounded-xl bg-gray-300 pb-0">
              <h1 className="mb-2 text-sm font-bold">
                Verificación por Fecha Nacimiento:
              </h1>
              <div className="grid grid-cols-2">
                <p>{data.validacion[0].Fecha_Nac}</p>
              </div>
              <div className="mt-3 flex w-full justify-center">
                <Button onClick={() => validando("nac")}>
                  Validacion Correcta
                </Button>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
};
